function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 12.61a.781.781 0 100-1.563.781.781 0 000 1.562z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 0C3.579 0 0 3.578 0 8c0 4.421 3.578 8 8 8 4.421 0 8-3.578 8-8 0-4.421-3.578-8-8-8zm0 14.75A6.746 6.746 0 011.25 8c0-3.73 3.019-6.75 6.75-6.75 3.73 0 6.75 3.019 6.75 6.75 0 3.73-3.019 6.75-6.75 6.75z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8 4.016a2.503 2.503 0 00-2.5 2.5.625.625 0 101.25 0c0-.69.56-1.25 1.25-1.25s1.25.56 1.25 1.25c0 .689-.56 1.25-1.25 1.25a.625.625 0 00-.625.625v1.562a.625.625 0 101.25 0V8.937A2.504 2.504 0 0010.5 6.516c0-1.379-1.121-2.5-2.5-2.5z"
});

function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), _ref, _ref2, _ref3);
}

export default SvgHelp;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/help.svg
// module id = 1288
// module chunks = 10